


















































import { Vue, Component, Prop } from "vue-property-decorator";
import CustomTableItem from "@/components/form/CustomTableItem.vue";
import CustomTableCol from "@/components/form/CustomTableCol.vue";
import TableActions from "@/components/form/TableActions.vue";
import BillPaymentForm from "@/components/bill/BillPaymentForm.vue";
import { Bill as IBill } from "@/api/models";

@Component({
  components: { BillPaymentForm, TableActions, CustomTableCol, CustomTableItem }
})
export default class PaymentsTabbleItem extends Vue {
  @Prop() item!: any;
  @Prop() bill!: IBill;
  @Prop() debtNumber!: number;
  isShowEditPayment: boolean = false;

  styleForDebt(paid: number) {
    return paid >= this.bill.amount ? "full-paid" : "debt";
  }

  deletePayment(id: string) {
    this.$emit("deletePayment", id);
  }

  editPayment(form: any) {
    let params: any = {
      ...form,
      paymentId: this.item.item.id
    };
    this.isShowEditPayment = false;
    this.$emit("editPayment", params);
  }
}
